var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-report-requests-list tab-table p-2"},[_c('condition-report-requests-table',{attrs:{"change-permission":"change_condition_report_request","delete-permission":"delete_condition_report_request"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }